module.exports = __webpack_public_path__ + "static/media/Exhaust Fan.49f10406.png";